import { plural } from "../../design/format/numbers.ts";

const deMeta = (meta: string | undefined) => (meta === undefined ? "" : ` de ${meta}`);

export const levelCopy = {
  nivel: { campanha: "Campanha", conjunto: "Conjunto de anúncios", anuncio: "Anúncio" },

  unidade: { um: "unidade", varios: "unidades" },

  sub: {
    comImposto: (valor: string) => `${valor} com imposto`,
    impostoDesconhecido: "imposto desconhecido",
    semPedidos: (resultados: string) => `sem ${resultados}`,
    lidoAs: (hora: string) => `lido às ${hora}`,
  },

  comparacao: { comparado: (dias: number) => `comparado com os ${dias} dias anteriores` },
  dobra: { mais: (n: number) => `Mais ${n} ${plural(n, "métrica", "métricas")}`, menos: "Menos métricas" },

  semValor: {
    "fusos-diferentes": "A loja e o Meta contam os dias em fusos diferentes: o retorno não é calculado.",
    "sem-anuncios": "Vendas ainda não conferidas: o Meta ainda não listou os anúncios desta campanha.",
    "sem-fonte": "Sem fonte de vendas: só os números do Meta.",
    "fonte-sem-campanha": (AFonte: string) => `${AFonte} não diz de qual campanha veio cada venda. Veja na conta.`,
    "imposto-desconhecido": "O imposto do Meta desta conta não foi conferido nas faturas.",
  },

  nota: {
    amadurecendo: "O Meta ainda pode revisar as compras dos últimos 7 dias.",
    outrosAnuncios: (valor: string) => `${valor} em vendas marcadas com esta campanha vieram de outros anúncios e não contam.`,
    semAnuncio: (valor: string) => `${valor} sem anúncio identificado (catálogo): contam para a campanha, não para conjuntos e anúncios.`,
    semAnuncioAbaixo: "Vendas sem anúncio identificado contam só para a campanha.",
    filhosSomamMenos: "Os conjuntos somam menos que a campanha: vendas sem anúncio identificado contam só para ela.",
    semFonte: "Sem fonte de vendas: tudo aqui é o que o Meta atribui.",
    soUtm: "Só pedidos com utm destas campanhas. A loja vende mais do que isso.",
    semMetas: "Sem metas definidas: a Nabla não julga se está bom ou ruim. Defina em Regras.",
    semVendas: (daFonte: string, n: number, w: { readonly vendas: string; readonly resultado: { readonly um: string } }) =>
      `sem leitura ${daFonte} ${plural(n, "neste dia", `nestes ${n} dias`)}: ${w.vendas}, retorno e custo por ${w.resultado.um} não aparecem`,
    semLeituraDoMeta: "O Meta ainda não foi lido aqui: os números aparecem depois da primeira leitura.",
    definicao: {
      "shopify-vendas-liquidas": "Vendas líquidas da Shopify: valor dos produtos menos descontos e devoluções, sem frete nem impostos.",
      "asaas-plano-inteiro":
        "Asaas: só o primeiro pagamento confirmado de cada cliente conta como venda. Um parcelamento soma o valor inteiro no dia da primeira parcela; as parcelas seguintes e as renovações de assinatura não somam.",
      "asaas-parcelas-pagas": "Asaas: cada pagamento confirmado soma no dia em que foi confirmado; só o primeiro de cada cliente conta como venda.",
      "asaas-plano-inteiro-por-plano":
        "Asaas: o primeiro pagamento confirmado de cada plano (cobrança avulsa, parcelamento ou assinatura) conta como venda. Um parcelamento soma o valor inteiro no dia da primeira parcela; as parcelas seguintes e as renovações de assinatura não somam.",
      "asaas-parcelas-pagas-por-plano": "Asaas: cada pagamento confirmado soma no dia em que foi confirmado; só o primeiro de cada plano (cobrança avulsa, parcelamento ou assinatura) conta como venda.",
    },
    mais: (n: number) => `+${n} ${plural(n, "nota", "notas")}`,
    menos: "Menos notas",
  },

  origem: {
    metaE: (aFonte: string) => `Meta e ${aFonte}`,
    janela: (fontes: string, periodo: string, fuso: string) => `${fontes} · ${periodo}${fuso === "" ? "" : ` ${fuso}`}`,
  },

  hoje: {
    ate: (hora: string, partes: string) => `Hoje até ${hora}: ${partes}.`,
    investidos: (valor: string) => `${valor} investidos`,
    entre: " · ",
    pedidosComVendas: (pedidos: string, vendas: string) => `${pedidos} (${vendas})`,
    ontem: (partes: string) => `Ontem a esta hora: ${partes}.`,
    ateOutraHora: (partes: string, hora: string) => `${partes} até ${hora}`,
    ontemCadaUma: (partes: string) => `Ontem a estas horas: ${partes}.`,
    semHora: (AFonte: string) => `${AFonte} não informa a hora das vendas.`,
  },

  porDia: (rotulo: string) => `${rotulo} por dia`,
  grafico: { abrir: "Ver por dia", fechar: "Fechar o gráfico" },
  porFilho: { conjunto: (rotulo: string) => `${rotulo} por conjunto`, anuncio: (rotulo: string) => `${rotulo} por anúncio`, tracejado: (meta: string) => `tracejado: meta ${meta}` },

  periodo: { rotulo: "Período", opcao: (dias: number) => `${dias} dias` },

  pista: {
    incompleto: (dias: string) => `${dias} ainda incompleto`,
    vendasOutros: (valor: string) => `${valor} de outros anúncios não contam`,
    semAnuncios: "vendas ainda não conferidas",
    travada: (nome: string) => `travada por ${nome}`,
    observadoFora: (quando: string) => `mudada fora da Nabla ${quando}`,
    nabla: { shadow: (titulo: string, quando: string) => `A Nabla faria: ${titulo} ${quando}`, act: (titulo: string, quando: string) => `A Nabla fez: ${titulo} ${quando}` },
    aprendizado: (n: number) => `em aprendizado: ${n} ${plural(n, "conjunto", "conjuntos")}`,
    curto: { aumentar: (pct: string) => `aumentar ${pct}`, reduzir: (pct: string) => `reduzir ${pct}`, pausar: "pausar", ativar: "ativar", desfazer: "desfazer", orcamento: "mudar o orçamento" },
    nota: (dia: string) => `nota de ${dia}`,
    notaMudou: (dia: string) => `nota de ${dia} · dados mudaram`,
    conjuntos: (n: number) => `${n} ${plural(n, "conjunto", "conjuntos")}`,
    esperaVoce: (n: number) => `${n} ${plural(n, "espera", "esperam")} você`,
    filhos: (conjuntos: number | undefined, anuncios: number) =>
      conjuntos === undefined ? `${anuncios} ${plural(anuncios, "anúncio", "anúncios")}` : `${conjuntos} ${plural(conjuntos, "conjunto", "conjuntos")} · ${anuncios} ${plural(anuncios, "anúncio", "anúncios")}`,
  },

  secao: {
    mudancas: "Mudanças",
    porDia: "Por dia",
    oQueMudou: "O que mudou",
    verTudoNoRegistro: "Ver tudo no registro →",
    contagemMudancas: (n: number) => `${n}`,
  },

  frase: {
    retorno: (r: string) => `retorno ${r}`,
    semDiaInteiro: (fuso: string) => `Ainda não há um dia completo de dados. A primeira leitura inteira fica pronta depois da meia-noite${fuso === "" ? "" : ` ${fuso}`}.`,
  },

  gruposSeparados: {
    fusos: "Estas contas contam os dias em fusos diferentes: os totais ficam separados.",
    moedas: "Estas contas usam moedas diferentes: os totais ficam separados.",
    impostos: "Numa conta o imposto do Meta é conhecido e na outra não: os totais ficam separados.",
    fontes: "Estas contas usam fontes de vendas diferentes: os totais ficam separados.",
    janelas: "Estas contas cobrem períodos diferentes: os totais ficam separados.",
  },

  campanha: {
    quatorzeDias: "14 dias",
    ultimoGasto: (dia: string) => `último gasto em ${dia}`,
    semGasto: "sem gasto nos últimos 14 dias",
    comprasMeta: { um: "compra (Meta)", varios: "compras (Meta)" },
    compras: { um: "compra", varios: "compras" },
    dentro: (meta?: string) => `dentro da meta${deMeta(meta)}`,
    fora: (quanto: string, acima: boolean, meta?: string) => `${quanto} ${acima ? "acima" : "abaixo"} da meta${deMeta(meta)}`,
    vezes: (vezes: string, meta?: string) => `${vezes}× a meta${deMeta(meta)}`,
    semImposto: (contraMeta: string) => `${contraMeta}, sem imposto`,
  },

} as const;
